module.exports = __webpack_public_path__ + "static/img/80016A_R_03_20170815_fit.cd6ca6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80016A_R_03_20170815_fit.png
// module id = co6k
// module chunks = 0